import React from 'react';
import './PressNews.css';

// Add Aivion-authored announcements here. Each item needs a date, category,
// title, summary and (optionally) a link. Keeping this separate from coverage
// makes company updates easy to publish without mixing them with press links.
const aivionUpdates = [
  {
    date: '2026 · Company announcement',
    category: 'UK–India collaboration',
    title: 'Aivion joins the Great North Mission',
    summary: 'Aivion is contributing to a major UK–India initiative focused on strengthening business, innovation and technology links between both regions.',
    url: 'https://www.pninews.com/amp/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-uk-india-links/'
  }
];

const missionCoverage = [
  ['Entrepreneurs Newsroom', 'https://entrepreneursnewsroom.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Edu News', 'https://edu-news.net/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['PNI News', 'https://www.pninews.com/amp/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-uk-india-links/'],
  ['Media Prism Creative', 'https://mediaprismcreative.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Global Biz Newsroom', 'https://globalbiznewsroom.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Business News Chronicle', 'https://businessnewschronicle.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['News in Pics', 'https://newsinpics.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Business Briefing Today', 'https://businessbriefingtoday.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Trade Insight News', 'https://tradeinsightnews.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['Market Dot News', 'https://marketdotnews.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links'],
  ['National Biz News', 'https://nationalbiznews.com/business/india-born-liverpool-ai-startup-joins-great-north-mission-to-strengthen-ukindia-links']
];

const PressNews = ({ fullPage = false }) => (
  <section id="press-news" className="press-news section" aria-labelledby="press-news-title">
    <div className="container">
      <div className="section-header press-news__header">
        <p className="press-news__eyebrow">PRESS &amp; NEWS</p>
        <h2 id="press-news-title">News &amp; updates</h2>
        <p>Company announcements and stories featuring Aivion.</p>
        {!fullPage && (
          <a className="press-news__archive-link" href="/news">
            View all news <span aria-hidden="true">↗</span>
          </a>
        )}
      </div>

      {fullPage && <div className="press-news__section-heading">
        <div>
          <p className="press-news__eyebrow">FROM AIVION</p>
          <h3>Aivion updates</h3>
        </div>
        <p>News and announcements from our team.</p>
      </div>}

      {fullPage && (aivionUpdates.length > 0 ? (
        <div className="press-news__grid press-news__updates-grid">
          {aivionUpdates.map((update) => (
            <article className="press-news__card" key={`${update.date}-${update.title}`}>
              <div className="press-news__date">{update.date}</div>
              <div className="press-news__tag">{update.category}</div>
              <h3>{update.title}</h3>
              <p>{update.summary}</p>
              {update.url && (
                <a href={update.url} className="press-news__link" target="_blank" rel="noreferrer">
                  Read the update <span aria-hidden="true">↗</span>
                </a>
              )}
            </article>
          ))}
        </div>
      ) : (
        <div className="press-news__empty-state">
          <span className="press-news__empty-icon" aria-hidden="true">✦</span>
          <div>
            <h4>Company updates coming soon</h4>
            <p>We’ll share announcements, launches and milestones from the Aivion team here.</p>
          </div>
        </div>
      ))}

      <div className={`press-news__section-heading ${fullPage ? 'press-news__coverage-heading' : 'press-news__preview-heading'}`}>
        <div>
          <p className="press-news__eyebrow">IN THE MEDIA</p>
          <h3>Aivion in the news</h3>
        </div>
        <p>Coverage and stories from external publications.</p>
      </div>

      <div className="press-news__grid">
        <article className="press-news__card">
          <div className="press-news__date">4 February 2026 · Growth Platform</div>
          <div className="press-news__tag">European Headquarters</div>
          <h3>Aivion chooses Liverpool for its first European base</h3>
          <p>
            Aivion has established its European base at CENTRAL TECH in Liverpool,
            strengthening its ability to work with UK organisations across education,
            financial services and beyond.
          </p>
          <a
            href="https://growthplatform.org/news/2026/02/aivion-chooses-liverpool-for-its-first-european-base/"
            target="_blank"
            rel="noreferrer"
            className="press-news__link"
          >
            Read the full announcement <span aria-hidden="true">↗</span>
          </a>
        </article>

        <article className="press-news__card press-news__video-card">
          <div className="press-news__date">Featured coverage · DD News</div>
          <h3>Startup ecosystem and India&apos;s next generation of innovators</h3>
          <div className="press-news__video-wrap">
            <iframe
              src="https://www.youtube.com/embed/U5n6Ll7Q14I?start=97"
              title="NextGen Bharat | Startup Ecosystem | DD News | Innovation"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
          <a
            href="https://www.youtube.com/watch?v=U5n6Ll7Q14I&t=97s"
            target="_blank"
            rel="noreferrer"
            className="press-news__link"
          >
            Watch on YouTube <span aria-hidden="true">↗</span>
          </a>
        </article>
      </div>

      <div className="press-news__mission">
        <div className="press-news__section-heading">
          <div>
            <p className="press-news__eyebrow">UK–INDIA COLLABORATION</p>
            <h3>Aivion joins the Great North Mission</h3>
          </div>
          <p>Syndicated coverage of Aivion’s work strengthening UK–India links.</p>
        </div>
        <div className="press-news__mission-card">
          <div>
            <div className="press-news__tag">Featured story</div>
            <h3>India-born Liverpool AI startup joins Great North Mission</h3>
            <p>The supplied articles cover the same announcement across multiple publications. We group them as one story and list each publication once.</p>
          </div>
          <div className="press-news__publication-list">
            {missionCoverage.map(([publication, url]) => (
              <a key={publication} href={url} target="_blank" rel="noreferrer">
                {publication} <span aria-hidden="true">↗</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PressNews;
